import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { CxMaterialConfigProviders } from '@bbraun/cortex';
import { HttpService } from '@bbraun/helpex/src/lib/http';

import { APP_ROUTES } from './app.routes';
import { SiteContextInterceptor } from '@/app/core/util/site-selection-interceptor/site-context.interceptor';
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
} from '@/app/shared/auth/authenticate/auth-config';
import { HttpErrorInterceptor } from '@/app/shared/ui-error-pages/util/interceptor/http-error.interceptor';
import { TranslocoRootModule } from '@/app/transloco-root.module';

const rootModules = [TranslocoRootModule, MsalModule];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES, withInMemoryScrolling(), withComponentInputBinding()),
    importProvidersFrom(...rootModules),
    CxMaterialConfigProviders,
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(),
    HttpService,
    { provide: HTTP_INTERCEPTORS, useClass: SiteContextInterceptor, multi: true },
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalGuard,
    MsalService,
    MsalBroadcastService,
  ],
};
